import React from 'react';
import {Video,MicOff,HeadphoneOff} from 'lucide-react';
import {useLang} from './i18n';
import './voice-roster-media.css';

export function VoiceRosterMedia({camera,streaming,muted,deafened}:{camera?:boolean;streaming?:boolean;muted?:boolean;deafened?:boolean}){
 const [,,tr]=useLang();
 if(!camera&&!streaming&&!muted&&!deafened)return null;
 return <span className="voice-roster-media">
  {camera&&<span className="voice-roster-camera" role="img" aria-label={tr('Camera on','Kamera an')} title={tr('Camera on','Kamera an')}><Video size={14} aria-hidden="true"/></span>}
  {streaming&&<em className="voice-roster-live">LIVE</em>}
  {muted&&<span role="img" aria-label={tr('Microphone muted','Mikrofon stumm')} title={tr('Microphone muted','Mikrofon stumm')}><MicOff size={14}/></span>}
  {deafened&&<span role="img" aria-label={tr('Deafened','Ton vollständig aus')} title={tr('Deafened','Ton vollständig aus')}><HeadphoneOff size={14}/></span>}
 </span>;
}
